export const PLUS = 'PLUS'
export const DIVIDE = 'DIVIDE'
export const MULTIPLY = 'MULTIPLY'
export const MINUS= 'MINUS'
